import React, { useState } from "react";
import { useNotification } from "providers/NotificationProvider";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import AuthHeader from "components/Headers/AuthHeader.js";
import AuthNavbar from "components/Navbars/AuthNavbar";
import userServices from "services/userServices";
import { useTranslation } from "context/TranslationProvider";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { notify } = useNotification();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      notify("error", t("toast.emailRequired", "Email is required"));
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await userServices.forgotPasswordEmail(email);

      if (response?.success) {
        notify("success", t(response.messageKey, response.message || t("auth.forgot-password.resetLinkMessage", "Reset password link sent to email.")));
        setEmail("");
      } else {
        const errorKey = response?.messageKey || response?.error;
        notify("error", t(errorKey, response?.message || t("toast.forgotPasswordFailed", "Something went wrong. Please try again.")));
      }
    } catch (error) {
      console.error(error);
      const backendError = error?.response?.data?.messageKey || error?.response?.data?.error;
      const backendMessage = error?.response?.data?.message;
      notify("error", t(backendError, backendMessage || t("toast.unexpectedError", "Unexpected error occurred.")));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <AuthNavbar
        logo={{
          innerLink: "/",
          imgSrc: require("assets/img/images/logo.png"),
          imgAlt: "...",
        }}
      />
      <AuthHeader title={t("auth.forgot-password.title", "Forgot Password")} lead={t("auth.login.forgot-password.lead", "Enter your email to reset password.")} />
      <Container className="mt--8 pb-5 px-3 px-md-4">
        <Row className="justify-content-center">
          <Col lg="5" md="7" xs="12">
            <Card className="bg-secondary border-0 mb-0 shadow">
              <CardBody className="px-lg-5 py-lg-5 px-4 py-4">
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-merge input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-email-83" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder={t("auth.forgot-password.emailLabel", "Email")}
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </InputGroup>
                  </FormGroup>
                  <div className="text-center">
                    <Button
                      color="warning"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? t("auth.forgot-password.sending", "Sending...") : t("auth.forgot-password.submitButton", "Send Reset Link")}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
            <Row className="mt-3">
              <Col xs="12" className="text-center text-md-left">
                <Link to="/login">
                  <small className="font-weight-bold">{t("button.backToLogin", "Back to Login")}</small>
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ForgotPassword;
